var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0657 3.71436H2.06567V12.2858H14.0657V3.71436Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0657 4.78564H2.06567V5.85697H14.0657V4.78564Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0657 6.92871H2.06567V8.00004H14.0657V6.92871Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0657 9.07129H2.06567V10.1426H14.0657V9.07129Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0657 11.2141H2.06567V12.2854H14.0657V11.2141Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06567 3.71436H2.06567V8.32975H8.06567V3.71436Z",
    fill: "#2E52B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40517 5.60498L4.30853 5.92349H3.99597L4.24889 6.12024L4.15225 6.43873L4.40517 6.24198L4.65792 6.43873L4.56131 6.12024L4.81422 5.92349H4.50164L4.40517 5.60498Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50164 7.07313L4.40517 6.75464L4.30853 7.07313H3.99597L4.24889 7.2699L4.15225 7.58838L4.40517 7.39161L4.65792 7.58838L4.56131 7.2699L4.81422 7.07313H4.50164Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18074 7.07313L3.08424 6.75464L2.98761 7.07313H2.67505L2.92796 7.2699L2.83133 7.58838L3.08424 7.39161L3.33702 7.58838L3.24041 7.2699L3.49328 7.07313H3.18074Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08424 5.60498L2.98761 5.92349H2.67505L2.92796 6.12024L2.83133 6.43873L3.08424 6.24198L3.33702 6.43873L3.24041 6.12024L3.49328 5.92349H3.18074L3.08424 5.60498Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40517 4.45581L4.30853 4.77435H3.99597L4.24889 4.97112L4.15225 5.28961L4.40517 5.09283L4.65792 5.28961L4.56131 4.97112L4.81422 4.77435H4.50164L4.40517 4.45581Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08424 4.45581L2.98761 4.77435H2.67505L2.92796 4.97112L2.83133 5.28961L3.08424 5.09283L3.33702 5.28961L3.24041 4.97112L3.49328 4.77435H3.18074L3.08424 4.45581Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72619 5.60498L5.62958 5.92349H5.31702L5.56991 6.12024L5.47332 6.43873L5.72619 6.24198L5.97899 6.43873L5.88235 6.12024L6.13527 5.92349H5.8227L5.72619 5.60498Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8227 7.07313L5.72619 6.75464L5.62958 7.07313H5.31702L5.56991 7.2699L5.47332 7.58838L5.72619 7.39161L5.97899 7.58838L5.88235 7.2699L6.13527 7.07313H5.8227Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14373 7.07313L7.04723 6.75464L6.9506 7.07313H6.63806L6.89093 7.2699L6.79432 7.58838L7.04723 7.39161L7.30001 7.58838L7.20337 7.2699L7.45629 7.07313H7.14373Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04723 5.60498L6.9506 5.92349H6.63806L6.89093 6.12024L6.79432 6.43873L7.04723 6.24198L7.30001 6.43873L7.20337 6.12024L7.45629 5.92349H7.14373L7.04723 5.60498Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72619 4.45581L5.62958 4.77435H5.31702L5.56991 4.97112L5.47332 5.28961L5.72619 5.09283L5.97899 5.28961L5.88235 4.97112L6.13527 4.77435H5.8227L5.72619 4.45581Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04723 4.45581L6.9506 4.77435H6.63806L6.89093 4.97112L6.79432 5.28961L7.04723 5.09283L7.30001 5.28961L7.20337 4.97112L7.45629 4.77435H7.14373L7.04723 4.45581Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUsa);
export default __webpack_public_path__ + "static/media/flag-usa.9897c89413c3890615fb4367da2aefb9.svg";
export { ForwardRef as ReactComponent };